enum GesCloudOrgSettingsPage {
	ORGANIZATION = "organization",
	MEMBERS = "members",
	SUBSCRIPTION = "subscription",
	PAYMENT_METHODS = "payment-methods",
	REPOS = "repos",
	AI_WALLET = "ai-wallet",
	TOKENS = "tokens",
	DOCUMENTS = "documents",
}

export default GesCloudOrgSettingsPage;
